// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React, { memo, useEffect, useMemo, useState } from 'react'
import moment from 'moment/moment'
import classNames from 'classnames'
import calendarIcon from '../../../../images/common/calendar.png'
import clockIcon from '../../../../images/common/clock.png'
import { getDays } from '../../../../utils/commonCalendar'
import { checkIsSameDay, FormatDate, isActiveEllipsisCheck, toTimeZone } from '../../../../utils/common'
import { DATE_FORMAT_TYPE_DATE } from '../../../../utils/constants'
import { getSpecialVisitTypeGroups } from 'ui_kit_qmd'

const ScheduleDetailView = memo(
  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
  ({ detailsInfo, customTimeZone, scheduleInfoRecurring, extraStyle, isPopUp, visitTypeGroups }) => {
    const [showRepeatPopUp, setShowRepeatPopUp] = useState(false)
    const [isOnHoverRepeatPopUp, setIsOnHoverRepeatPopUp] = useState(false)
    const availableStates = detailsInfo?.availableStatesCodes

    const applicableRow = availableStates?.join('; ') ?? 'N/A'
    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    const matchedGroup = visitTypeGroups?.find((g) => g.VisitTypeGroupId === detailsInfo?.visitTypeGroupId)
    const isSpecial = matchedGroup ? !matchedGroup.IsDefault : false
    const specialGroups = getSpecialVisitTypeGroups(visitTypeGroups)
    const hasMultipleGroups = (visitTypeGroups?.length ?? 0) > 1
    useEffect(() => {
      const timer = setInterval(() => {
        isActiveEllipsisCheck('repeat', setShowRepeatPopUp)
      }, 1000)
      return () => clearInterval(timer)
    }, [])

    const turnOffIsOnHoverRepeatPopUp = () => {
      setIsOnHoverRepeatPopUp(false)
    }
    const turnOnIsOnHoverRepeatPopUp = () => {
      setIsOnHoverRepeatPopUp(true)
    }

    const isStartAndEndTimelapseIsTheSameDate = useMemo(
      () =>
        checkIsSameDay(
          toTimeZone(detailsInfo.timeInUTC.start, customTimeZone),
          toTimeZone(detailsInfo.timeInUTC.end, customTimeZone),
        ),
      [customTimeZone, detailsInfo.timeInUTC.end, detailsInfo.timeInUTC.start],
    )
    return (
      <div className='availability-details-container' style={extraStyle}>
        <div
          className={
            isStartAndEndTimelapseIsTheSameDate ? 'availability-details-row' : (
              'availability-details-row-overlap-version'
            )
          }>
          <div className='availability-details-inner-row'>
            <img className='availability-detils-img' src={calendarIcon} alt='Date' />
            {isStartAndEndTimelapseIsTheSameDate ?
              <span className='availability-details-text'>
                {FormatDate(detailsInfo.timeInUTC.start, 'Date', customTimeZone)}
              </span>
            : null}
          </div>
          {isStartAndEndTimelapseIsTheSameDate ?
            <div className='availability-details-inner-row'>
              <img className='availability-detils-img' src={clockIcon} alt='Time' />
              <span className='availability-details-text'>
                {FormatDate(detailsInfo.timeInUTC.start, 'Time', customTimeZone)} -{' '}
                {FormatDate(detailsInfo.timeInUTC.end, 'Time', customTimeZone)}
              </span>
            </div>
          : <div className='availability-details-inner-row-overlap-version'>
              <span
                className={
                  isStartAndEndTimelapseIsTheSameDate ? 'availability-details-text' : (
                    'availability-details-text-overlap-version'
                  )
                }>
                {moment(detailsInfo.fromDateTime).format('dddd MMM D YYYY, h:mma')} -{' '}
                {moment(detailsInfo.toDateTime).format('dddd MMM D YYYY, h:mma')}
              </span>
            </div>
          }
        </div>
        <div className='availability-details-line-break' />
        {scheduleInfoRecurring ?
          <div className={classNames('availability-details-inner-row', {}, ['withMarginTop'])}>
            <div
              className={classNames('availability-details-inner-row-repeat', {}, ['withoutMarginBottom'])}
              onMouseLeave={turnOffIsOnHoverRepeatPopUp}
              onBlur={turnOffIsOnHoverRepeatPopUp}
              onMouseOver={turnOnIsOnHoverRepeatPopUp}
              onFocus={turnOnIsOnHoverRepeatPopUp}>
              <div />
              <span className='availability-details-text-overlap-version-repeat' id='repeat'>
                {`Repeats weekly ${
                  scheduleInfoRecurring.RecurringType !== 'daily' ?
                    ` on ${getDays(scheduleInfoRecurring.WeekDays)}`
                  : ''
                }`}
              </span>
            </div>
            <div className={classNames('availability-details-inner-row-end', {}, ['withoutMarginBottom'])}>
              <img className='availability-detils-img' src={calendarIcon} alt='Date' />
              <span className='availability-details-text-overlap-version'>
                End date:{' '}
                {FormatDate(
                  scheduleInfoRecurring.EndDateTime ?
                    scheduleInfoRecurring.EndDateTime
                  : moment(detailsInfo.fromDateTime).add(1, 'year'),
                  DATE_FORMAT_TYPE_DATE,
                  customTimeZone,
                )}
              </span>
            </div>
          </div>
        : null}
        {showRepeatPopUp && isOnHoverRepeatPopUp ?
          // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
          <div className='detailsViewRepeatDatesToolTip' style={isPopUp ? null : { left: 16 }}>
            {`Repeats weekly ${
              scheduleInfoRecurring.RecurringType !== 'daily' ? ` on ${getDays(scheduleInfoRecurring.WeekDays)}` : ''
            }`}
          </div>
        : null}
        {scheduleInfoRecurring ?
          <div className='availability-details-line-break' />
        : null}
        <div className='appointment-info-applicable-states-section'>
          {hasMultipleGroups && matchedGroup ?
            <div className={classNames('availability-details-row', ['availability-label-info', 'cursor-default'])}>
              Visit type(s):{' '}
              {/*
               // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered */}
              {isSpecial ? matchedGroup.Name : `All visit types except ${specialGroups.map((g) => g.Name).join(', ')}`}
            </div>
          : null}
          <div className={classNames('availability-details-row', ['availability-label-info', 'cursor-default'])}>
            Applicable state(s): {applicableRow || 'N/A'}
          </div>
          {detailsInfo.IsAppliedForAllLicensedStates && applicableRow ?
            <div className='appointment-info-applicable-states-all-states-label'>*Applies to all licensed states</div>
          : null}
        </div>
      </div>
    )
  },
)

export default ScheduleDetailView
